export const isComponentVisible = function isComponentVisible(id) {
	const { focussed, selected } = this.props;
	return (selected.includes(id) && (!focussed || focussed === id));
};

export const isComponentFullScreen = function isComponentFullScreen(id) {
	const { focussed } = this.props;
	return focussed === id;
};

export const shouldComponentBeDeleted = function shouldComponentBeDeleted(id) {
	const { itemToRemove } = this.props;
	return itemToRemove === id;
};



// WEBPACK FOOTER //
// ./src/ui/interaction/children/ugcvisualization/utils.js